// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__qGpkr","subheader":"ReorderModal_subheader__1SQ0L","listWrap":"ReorderModal_listWrap__3w6Aw"};